export enum WorkflowEnum {
  APPROVAL = "APPROVAL",
  BLACKLIST = "BLACKLIST",
  BLACKLIST_RETURN = "BLACKLIST_RETURN",
  BLACKLIST_REVERSED = "BLACKLIST_REVERSED",
  BLACKLIST_REVERSED_RETURN = "BLACKLIST_REVERSED_RETURN",
  SUSPEND = "SUSPEND",
  SUSPEND_RETURN = "SUSPEND_RETURN",
  SUSPEND_REVERSED = "SUSPEND_REVERSED",
  SUSPEND_REVERSED_RETURN = "SUSPEND_REVERSED_RETURN",
  SUSPEND_BLACKLIST = "SUSPEND_BLACKLIST",
  SUSPEND_BLACKLIST_RETURN = "SUSPEND_BLACKLIST_RETURN",
  SUSPEND_BLACKLIST_REVERSED = "SUSPEND_BLACKLIST_REVERSED",
  SUSPEND_BLACKLIST_REVERSED_RETURN = "SUSPEND_BLACKLIST_REVERSED_RETURN",
}
